import { useSendVerifyEmailMutation } from "../redux/slices/api/userApi";
import notify from "../components/common/notify";
import { handleError } from "./useApi";

// Custom hook to handle sending email verification
const useSendEmailVerification = () => {
  const [sendVerifyEmail, { isLoading: sendEmailLoading }] =
    useSendVerifyEmailMutation();

  const handleSendVerifyEmail = async () => {
    try {
      const res = await sendVerifyEmail().unwrap();
      notify(res?.message, "success");
    } catch (error) {
      handleError(error, null, true);
    }
  };

  return { handleSendVerifyEmail, sendEmailLoading };
};

export default useSendEmailVerification;